
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'YbSvgDownload',
  props: {
    colors: {
      type: Array as PropType<string[]>,
      default: () => {
        return []
      }
    },
    width: {
      type: String,
      default: '28'
    },
    height: {
      type: String,
      default: '28'
    }
  }
})
